import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Message } from 'primeng/api';
import { ErroService } from 'src/app/admihair/service/erro.service';
import { NgForm } from '@angular/forms';
import { Usuario } from 'src/app/admihair/api/dto/usuario';
import { UsuarioService } from 'src/app/admihair/service/usuario.service';


@Component({
  selector: 'app-usuario-inserir',
  templateUrl: './usuario-inserir.component.html',
  styleUrls: ['./usuario-inserir.component.scss']
})
export class UsuarioInserirComponent implements OnInit {

  messages: Message[] = [{ severity: 'success', summary: 'Sucesso', detail: 'Cliente salvo' }];
  messagemVisivel: boolean = false;
  tipos: string[] = [
    'EMPRESA',
    'FRANQUIA'
  ]
  progressoRequisicao: boolean = false;

  constructor(private usuarioService: UsuarioService,
    private erroService: ErroService,
    private _router: Router,
    private _activatedRoute: ActivatedRoute) { }

  ngOnInit(): void { }

  salvar(form: NgForm) {
    this.progressoRequisicao = true;
    const usuario: Usuario = form.value;
    if (!usuario.apelido) {
      usuario.apelido = this.formatarApelido(usuario.nome);
    }

    usuario.login = usuario.email;
    usuario.primeiroAcesso = true;
    usuario.situacaoConfirmacaoConta = 'AGUARDANDO_CONFIRMACAO';
    console.log(usuario)
    this.usuarioService.salvar(usuario).subscribe({
      next: () => {
        this.progressoRequisicao = false;
        this.messages = this.erroService.handleSuccess();
        this.messagemVisivel = true;
        this.rolarTela();
      },
      error: (err: any) => {
        this.progressoRequisicao = false;
        this.messages = this.erroService.handleErro(err);
        this.messagemVisivel = true;
        this.rolarTela();
      }
    })

  }

  formatarApelido(nome?: string): string {
    return nome !== undefined ? nome.split(' ')[0] : '';
  }


  navigateToFirstChild() {
    this._router.navigate(["/auth/login"], { relativeTo: this._activatedRoute })
  }

  editarIndicadorCliente(id: number) {
    this._router.navigate(["/apps/indicador-cliente/editar/" + id], { relativeTo: this._activatedRoute })
  }

  rolarTela() {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }


}
